module.exports = __webpack_public_path__ + "img/default-image.d1dd65fa.png";